import React, { useState, useEffect } from "react";
import axios from "axios";
import { Home, Radio, MapPin, Navigation, Loader2, X } from "lucide-react";
import { AuthImage } from "./PhotoField";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const mapsUrl = (lat, lng) => `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
const hasCoord = (lat, lng) => lat != null && lng != null && !(Number(lat) === -6.9147 && Number(lng) === 107.6098);

const FotoCard = ({ icon: Icon, title, subtitle, path, lat, lng, testid }) => (
  <div className="p-3 bg-slate-900 border border-slate-800 rounded-xl space-y-2" data-testid={testid}>
    <div className="flex items-center justify-between gap-2">
      <div className="min-w-0">
        <p className="text-xs font-bold text-white flex items-center gap-1.5"><Icon className="w-3.5 h-3.5 text-cyan-400" />{title}</p>
        {subtitle && <p className="text-[10px] text-slate-400 truncate">{subtitle}</p>}
      </div>
      {hasCoord(lat, lng) && (
        <a href={mapsUrl(lat, lng)} target="_blank" rel="noreferrer" className="px-2 py-1 rounded-lg bg-cyan-600/20 border border-cyan-600/40 text-cyan-300 text-[10px] font-bold flex items-center gap-1 shrink-0" data-testid={`${testid}-maps`}>
          <Navigation className="w-3 h-3" />Rute
        </a>
      )}
    </div>
    <AuthImage path={path} alt={title} className="w-full h-48 rounded-lg" testid={`${testid}-img`} />
  </div>
);

// Foto rumah pelanggan + foto ODP-nya (otomatis dari ODP yang terhubung)
export const PelangganFotoPanel = ({ pelangganId }) => {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setInfo(null); setError("");
    axios.get(`${BACKEND_URL}/api/pelanggan/${pelangganId}/foto-info`, { withCredentials: true })
      .then((r) => setInfo(r.data))
      .catch(() => setError("Gagal memuat foto pelanggan"));
  }, [pelangganId]);

  if (error) return <p className="text-xs text-rose-400">{error}</p>;
  if (!info) return <p className="text-xs text-slate-500 flex items-center gap-2"><Loader2 className="w-3.5 h-3.5 animate-spin" />Memuat foto...</p>;
  const odp = info.odp;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="pelanggan-foto-panel">
      <FotoCard icon={Home} title="Foto Rumah Pelanggan" subtitle={info.alamat} path={info.foto_rumah_path} lat={info.lat} lng={info.lng} testid="foto-rumah-card" />
      <FotoCard icon={Radio} title={odp ? `Foto ODP ${odp.kode}` : "Foto ODP"}
        subtitle={odp ? `${odp.nama}${info.odp_port ? ` · port ${info.odp_port}` : ""}${odp.lokasi_gang ? ` · ${odp.lokasi_gang}` : ""}` : "Pelanggan belum terhubung ke ODP"}
        path={odp?.foto_path} lat={odp?.lat} lng={odp?.lng} testid="foto-odp-card" />
    </div>
  );
};

export const PelangganFotoDialog = ({ pelanggan, onClose }) => (
  <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" data-testid="pelanggan-foto-dialog">
    <div className="bg-[#0f172a] border border-slate-700 rounded-2xl w-full max-w-2xl shadow-2xl max-h-[90vh] overflow-y-auto">
      <div className="flex items-center justify-between px-5 py-4 border-b border-slate-800 sticky top-0 bg-[#0f172a] z-10">
        <div>
          <h3 className="text-sm font-bold text-white">{pelanggan.nama}</h3>
          <p className="text-[11px] text-slate-400 flex items-center gap-1"><MapPin className="w-3 h-3 text-purple-400" />{pelanggan.alamat}</p>
        </div>
        <button onClick={onClose} className="text-slate-400 hover:text-white p-1" data-testid="pelanggan-foto-dialog-close"><X className="w-5 h-5" /></button>
      </div>
      <div className="p-5"><PelangganFotoPanel pelangganId={pelanggan.id} /></div>
    </div>
  </div>
);
